import { z } from 'zod';
import { FINANCIAL_PRODUCT } from '../constants';
import { applicantMetadata, directDebitAgreement, generateSchema, repaymentAccount } from '../shared';
import { ApplicationStep } from '../types';
import { baseApplicationStep } from './baseApplication';

const defaultSchema = {
  applicant: applicantMetadata.pick({ type: true }).merge(
    z.object({
      termsAndConditions: directDebitAgreement,
    }),
  ),
};

const electrify2515RepaymentAccountSchema = {
  applicant: applicantMetadata.pick({ type: true }).merge(
    z.object({
      termsAndConditions: z.object({
        directDebitStatement: z.string().optional(),
        authoriseBrighteStatement: z.string().optional(),
      }),
    }),
  ),
};

const customSchemas = {
  [FINANCIAL_PRODUCT.ELECTRIFY_2515]: electrify2515RepaymentAccountSchema,
};

export const repaymentAccountSchema = generateSchema<typeof customSchemas, typeof defaultSchema>({
  customSchemas,
  defaultSchema,
});

export const updateApplicationPaymentSchema = repaymentAccountSchema.and(
  z
    .object({
      step: z.literal(ApplicationStep.PaymentDetails),
      payment: repaymentAccount,
    })
    .and(baseApplicationStep),
);
